import { Dropdown } from 'react-bootstrap'

interface PickedUpMenuProps {
  orderId: number | undefined
  handleUpdateStatus: (id_order: number, status: string) => void
}
interface OperinMenuProps {
  orderId: number | undefined
  handleSendNotification: (id_order: number, status: string) => void
}
interface DeletedMenuProps {
  orderId: number | undefined
  handleDelete: (id_order: number) => void
}

export function PickedUpMenu({ orderId, handleUpdateStatus }: PickedUpMenuProps) {
  return (
    <>
      <LinkedItemMenu
        orderId={orderId}
        url={'/livraisons/dupliquer/'}
        label='Dupliquer cette commande'
        icon='ri-file-copy-2-line'
      />
      <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'left_for_customer_service'}
        icon='ri-arrow-go-back-line'
        label='Commande retournée au service client'
      />
      <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'operin'}
        icon='ri-inbox-archive-line'
        label='Commande déposée dans la EasyBox'
      />
      <CancelledItemMenu orderId={orderId} handleUpdateStatus={handleUpdateStatus} />
    </>
  )
}

export function ReadyForDeliveryMenu({ orderId, handleUpdateStatus }: PickedUpMenuProps) {
  return (
    <>
       <LinkedItemMenu
        orderId={orderId}
        url={'/livraisons/dupliquer/'}
        label='Dupliquer cette commande'
        icon='ri-file-copy-2-line'
      />
       <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'picked_up'}
        icon='ri-truck-line'
        label='Commande en cours de livraison'
      />
    </>
  )
}

export function CreatedMenu({ orderId, handleUpdateStatus }: PickedUpMenuProps) {
  return (
    <>
       <LinkedItemMenu
        orderId={orderId}
        url={'/livraisons/dupliquer/'}
        label='Dupliquer cette commande'
        icon='ri-file-copy-2-line'
      />
       <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'ready_for_delivery'}
        icon='ri-inbox-unarchive-line'
        label='Commande prête pour la livraison'
      />
    </>
  )
}

export function OperoutMenu({ orderId, handleUpdateStatus }: PickedUpMenuProps) {
  return (
    <>
      <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'left_for_customer_service'}
        icon='ri-arrow-go-back-line'
        label='Commande retournée au service client'
      />
      <StatusItemMenu
        orderId={orderId}
        handleUpdateStatus={handleUpdateStatus}
        status={'cancel'}
        icon='ri-close-circle-line'
        label='Annuler cette commande'
      />
    </>
  )
}

export function OperinMenu({ orderId, handleSendNotification }: OperinMenuProps) {
  return (
    <>
       <LinkedItemMenu
        orderId={orderId}
        url={'/livraisons/dupliquer/'}
        label='Dupliquer cette commande'
        icon='ri-file-copy-2-line'
      />
      <SendItemMenu
        orderId={orderId}
        handleSendNotification={handleSendNotification}
        status={'sms'}
        icon='ri-message-2-line'
        label="Renvoyer le SMS"
      />
      <SendItemMenu
        orderId={orderId}
        handleSendNotification={handleSendNotification}
        status={'email'}
        icon='ri-mail-send-line'
        label="Renvoyer l'email"
      />
    </>
  )
}



/**
 * 
 * Items menu for orders
 * 
 */

export function CancelledItemMenu({ orderId, handleUpdateStatus }: PickedUpMenuProps) {
  return (
    <Dropdown.Item
      className='border-bottom py-2'
      onClick={() => handleUpdateStatus(Number(orderId), 'cancel')}
    >
      <i className='ri-close-circle-line ri-lg mr-2 align-middle'></i>
      Annuler cette commande
    </Dropdown.Item>
  )
}

export function DeletedItemMenu({ orderId, handleDelete }: DeletedMenuProps) {
  return (
    <Dropdown.Item
      className='border-bottom py-2'
      onClick={() => handleDelete(Number(orderId))}
    >
      <i className='ri-delete-bin-2-line ri-lg mr-2 align-middle'></i>
      Supprimer cette commande
    </Dropdown.Item>
  )
}

/**
 * generic component for status item menu
 */

type StatusItemMenuProps = {
  orderId: number | undefined
  handleUpdateStatus: (id_order: number, status: string) => void
  status: string
  icon: string
  label: string
}

export function StatusItemMenu({
  orderId,
  handleUpdateStatus,
  status,
  icon,
  label,
}: StatusItemMenuProps) {
  return (
    <Dropdown.Item
      className="border-bottom py-2"
      onClick={() => handleUpdateStatus(Number(orderId), status)}
    >
      <i className={`${icon} ri-lg mr-2 align-middle`}></i>
      {label}
    </Dropdown.Item>
  )
}
type SendItemMenuProps = {
  orderId: number | undefined
  handleSendNotification: (id_order: number, status: string) => void
  status: string
  icon: string
  label: string
}

export function SendItemMenu({
  orderId,
  handleSendNotification,
  status,
  icon,
  label,
}: SendItemMenuProps) {
  return (
    <Dropdown.Item
      className="border-bottom py-2"
      onClick={() => handleSendNotification(Number(orderId), status)}
    >
      <i className={`${icon} ri-lg mr-2 align-middle`}></i>
      {label}
    </Dropdown.Item>
  )
}

export function LinkedItemMenu({ orderId, url, label, icon }: {orderId: number | undefined, url: string, label: string, icon?: string}) {
    return (
        <Dropdown.Item className='border-bottom py-2' href={url + orderId}>
        {icon && <i className={`${icon} ri-lg mr-2 align-middle`}></i>}
        {label}
      </Dropdown.Item>
  )
}   
